{
  "city-card": {
    "text": {
      "explore-top-salons": "Découvrez les meilleurs salons à"
    }
  }
}
